import component from './CardLayoutMobile';

export default component;
